import { useMutation, useQueryClient } from "@tanstack/react-query";
import { followEntityService, unfollowEntityService } from "../services/follow";
import { Entity } from "../../../../types/types/entity.types";
import { entityKeys } from "../queryKeys";

export const useEntityFollow = (entityId: number) => {
  const queryClient = useQueryClient();

  const followMutation = useMutation({
    mutationFn: () => followEntityService(entityId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["NetworkList"] });
      queryClient.invalidateQueries({ queryKey: ["EntityProfile"] });
      queryClient.invalidateQueries({ queryKey: entityKeys.details(String(entityId)) });

      queryClient.setQueryData<Entity>(["entity", entityId], (old) => {
        if (!old) return old;
        return {
          ...old,
          isFollowing: true,
          followersCount: old.followersCount + 1,
        };
      });
    },
  });

  const unfollowMutation = useMutation({
    mutationFn: () => unfollowEntityService(entityId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["NetworkList"] });
      queryClient.invalidateQueries({ queryKey: ["EntityProfile"] });
      queryClient.invalidateQueries({ queryKey: entityKeys.details(String(entityId)) });

      queryClient.setQueryData<Entity>(["entity", entityId], (old) => {
        if (!old) return old;
        return {
          ...old,
          isFollowing: false,
          followersCount: old.followersCount - 1,
        };
      });
    },
  });

  return {
    follow: followMutation.mutate,
    unfollow: unfollowMutation.mutate,
    isFollowing: followMutation.isPending,
    isUnfollowing: unfollowMutation.isPending,
  };
};
